import { useLocalStore } from 'mobx-react-lite';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

export default () => {
  const presenter = useLocalStore(() => ({
    async onClick() {
      const group = Entities.GroupsStore.activeGroup;
      if (group && group.canBeScheduled) {
        await Tasks.group.setActiveGroup({ groupId: group.scheduleGroupId });
      }
    },
  }));

  return presenter;
};
